import { Stack, Typography } from '@mui/material'
import { Button } from 'utoniq-ui'

import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame, Template } from '@/core/architecture'

export * from './fragments'

export type State = {}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {}

export const DeactivationCompletionTemplate: Template<State, Action> = ({}) => {
  const { routerNames } = useRouter()
  return (
    <>
      <Head title={routerNames.DeactivationCompletion} />
      <BaseLayout margin header={{}}>
        <DeactivationCell />
      </BaseLayout>
    </>
  )
}

export const DeactivationCell: Cell = () => {
  const { routerPages } = useRouter()
  const { t } = useTranslation('deactivationCompletion')
  return (
    <CellFrame>
      <Stack spacing={2} alignItems="center">
        <Typography variant="h5">
          {t('withdrawalProcedureCompleted')}
        </Typography>
        <Typography variant="body2">{t('thankDesc')}</Typography>
      </Stack>
      <Stack sx={{ py: 3, mt: 4 }} alignItems="center">
        <Button size="large" sx={{ width: 244 }} href={routerPages.Top}>
          {t('topPage')}
        </Button>
      </Stack>
    </CellFrame>
  )
}
